import { Body, FlexBox, Headline, Icon } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import { AuctionAccessAccountDetail } from '../../shared/AuctionAccessAccountDetail';
import { formatAuctionAccessId, formatPhotoIdLastFour } from '../helpers';
import { LookupDetailsGrid } from '../../shared/styles';
import { trackAuctionAccessError } from '../tracking';
import { LookupActions } from './LookupActions';

export const AuctionAccessNotFound = ({
	onContinueManually,
	onTryAgain,
	submittedAuctionAccessId,
	submittedPhotoIdLastFour,
}) => {
	const { t } = useTranslation(['signup']);

	const handleTryAgain = () => {
		trackAuctionAccessError('try_again');
		onTryAgain();
	};

	const handleContinueWithoutAuctionAccess = () => {
		trackAuctionAccessError('continue_without');
		onContinueManually();
	};

	return (
		<FlexBox flexDirection="column" gap="lg">
			<FlexBox alignItems="center" gap="sm">
				<Icon color="secondary" name="exclamation" size="smaller" />
				<Headline size="H3">{t('signup:auctionAccessLookup.notFound.title')}</Headline>
			</FlexBox>
			<Body>{t('signup:auctionAccessLookup.notFound.subTitle')}</Body>
			<FlexBox background="secondary" borderRadius="lg" flexDirection="column" gap="md" padding="lg">
				<Body bold>{t('signup:auctionAccessLookup.notFound.informationEntered')}</Body>
				<LookupDetailsGrid>
					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.notFound.auctionAccessId')}
						value={formatAuctionAccessId(submittedAuctionAccessId)}
					/>
					<AuctionAccessAccountDetail
						label={t('signup:auctionAccessLookup.notFound.photoIdLastFour')}
						value={formatPhotoIdLastFour(submittedPhotoIdLastFour)}
					/>
				</LookupDetailsGrid>
			</FlexBox>
			<LookupActions
				onContinueManually={handleContinueWithoutAuctionAccess}
				onTryAgain={handleTryAgain}
				tryAgainCopy={t('signup:auctionAccessLookup.notFound.tryAgain')}
				continueManuallyCopy={t('signup:auctionAccessLookup.notFound.continueWithoutAuctionAccess')}
			/>
		</FlexBox>
	);
};
